import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/memberships/:membershipId/validator-settings/';

type MembershipValidatorUpdateFnType = typeof membershipValidatorUpdate;

export type ValidatorUpdateDTO = {
    parkingId: string;
    membershipId: string;
};

const membershipValidatorUpdate = ({ parkingId, membershipId, ...data }: ValidatorUpdateDTO) => {
    return axios.put(formatResourcePath(RESOURCE, { parkingId, membershipId }), data);
};

interface UseMembershipValidatorUpdateOptions
    extends MutationConfig<MembershipValidatorUpdateFnType, GeneralSmartParkError> {}

export const useMembershipValidatorUpdate = (options: UseMembershipValidatorUpdateOptions) =>
    useMutation({
        mutationFn: membershipValidatorUpdate,
        ...options,
    });
